import { Injectable, inject } from '@angular/core';
import { profileModel } from '../Model/profile.model';
import { SharedApiService } from '../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class profileService {


  private endpoint = `Portal/User/GetCurrentUserWeb`
  private endpoint2 = `Portal/User/GetUserById`
  private endpoint3 = `Account/UpdateProfile/UpdateProfile`
  private endpoint4 = `Portal/User/GetImage/`
  private endpoint5 = `Account/SendCodeChangeEmail`
  private endpoint6 = `Account/ChangeEmailWithCode`
  private endpoint7 = `Account/ChangeName`
  private endpoint8 = `Account/ChangeLastName`
  private endpoint9 = `Account/ChangeUserImage`

  private SharedApiService = inject(SharedApiService)

  UpdateUserData(params: any) {
    return this.SharedApiService.UpdateToJsonOrFormWithToken<any>(this.endpoint3, params)
  }

  GetUserData(id: number) {
    return this.SharedApiService.getAll2(this.endpoint2 + `?UserId=` + id)
  }

  GetCurrentUser() {
    return this.SharedApiService.getAll2(this.endpoint)
  }

  GetUserImag(userName: string | null) {
    return this.SharedApiService.getImage(this.endpoint4 + userName)
  }

  SendCodeOfChangeEmail(email: string) {
    return this.SharedApiService.postData2<any>(this.endpoint5, { "email": email })
  }

  changeEmail(params: any) {
    return this.SharedApiService.postData2<any>(this.endpoint6, params)
  }

  changeFirstName(params: any) {
    return this.SharedApiService.postData2<any>(this.endpoint7, params)
  }

  changeLastName(params: any) {
    return this.SharedApiService.postData2<any>(this.endpoint8, params)
  }

  changeImage(params: any) {
    return this.SharedApiService.postData2<any>(this.endpoint9, params)
  }
}
